import axios from 'axios';
import React, { PropsWithChildren, useRef, useState } from 'react';
import useRoute from '@/Hooks/useRoute';
import Button from '@/Components/Buttons/Button';
import Input from '@/Components/Inputs/Input';
import Modal from '@/Components/Display/Modal';

export default function ConfirmPasswordJetstream({ onConfirm, children }) {
  const route = useRoute();
  const [confirmingPassword, setConfirmingPassword] = useState(false);
  const [form, setForm] = useState({
    password: '',
    error: '',
    processing: false,
  });
  const passwordRef = useRef(null);

  function startConfirmingPassword() {
    axios.get(route('password.confirmation')).then(response => {
      if (response.data.confirmed) {
        onConfirm();
      } else {
        setConfirmingPassword(true);

        setTimeout(() => passwordRef.current.focus(), 250);
      }
    });
  }

  function confirmPassword() {
    setForm({ ...form, processing: true });

    axios
      .post(route('password.confirm'), {
        password: form.password,
      })
      .then(() => {
        closeModal();
        setTimeout(() => onConfirm(), 250);
      })
      .catch(error => {
        setForm({
          ...form,
          processing: false,
          error: error.response.data.errors.password[0],
        });
        passwordRef.current.focus();
      });
  }

  const handleKeypress = e => {
    //it triggers by pressing the enter key
    if (e.keyCode === 13) {
      confirmPassword();
    }
  };

  function closeModal() {
    setConfirmingPassword(false);
    setForm({ processing: false, password: '', error: '' });
  }

  return (
    <div>
      <div onClick={startConfirmingPassword}>{children}</div>
      {confirmingPassword && (
        <Modal
          Modal
          modalState={confirmingPassword}
          onClose={closeModal}
          modalHeader="Confirm Password"
          modalSubHeader="For your security, please confirm your password to continue."
        >
          <div className="mt-4">
            <Input
              type="password"
              className="mt-1 block w-full"
              placeholder="Password"
              value={form.password}
              onChange={e =>
                setForm({ ...form, password: e.currentTarget.value })
              }
              error={form.error}
            />
          </div>
          <div className="mt-6 grid grid-cols-1 items-center justify-end gap-6 lg:grid-cols-4">
            <div className="order-1 col-span-1 lg:order-2 lg:col-span-1">
              <Button style="border" variant="grey" onClick={closeModal}>
                Cancel
              </Button>
            </div>
            <div className="order-2 col-span-1 lg:order-1 lg:col-span-3">
              <Button
                disabled={form.processing}
                onClick={confirmPassword}
                style="admin"
                variant="dark"
              >
                Confirm
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}
